import {  useEffect, useState } from "react";
import styled from "styled-components";
import PopUpWarning, { PopUpCaller } from "../PopUpWarning/PopUpWarning";
import { ApiConnectEmailConfirm, ApiConnectValidateGeneratedCode } from "../api/LionsUserApiConect";
import EmailMessage from "./EmailMessage";
import MailImg from "./img/mailimg.png"


function GenerateValidationCodeFunction(userName, userEmail, messageType) {
        ApiConnectEmailConfirm(userEmail, userName, messageType);
        return;          
    }

function EmailConfirmFormulary(props) {


    const [ValideCodeButtonColor, setValideCodeButtonColor] = useState("rgba(112, 118, 113, 0.5)");
    const [availableValideCode, setAvailableValideCodeSubmit] = useState("none");
    const [expirationTime, setExpirationTime] = useState("02:00")

    function validationCodeCheck(inputCode){

    if(inputCode === "") {
        setValideCodeButtonColor("rgba(112, 118, 113, 0.5)");
        setAvailableValideCodeSubmit("none");
        return;

        } else { 
            setValideCodeButtonColor("rgb(28, 83, 160)");
            setAvailableValideCodeSubmit("auto");
        };
        return;
        }

    function executeAction(CodefieldValue) {

        var negado = "Código Incorreto! Verifique seu email e tente novamente"
        var expirado = "Código Expirado! Reinicie o processo"

        let result = ApiConnectValidateGeneratedCode(props.userMail, CodefieldValue).
        then(result => {

            if(result.status === 401) {
                PopUpCaller(expirado,"rgba(191, 18, 18, 0.8)", 10000);
                return;  
            }

            if(result.data == false){
                PopUpCaller(negado,"rgba(191, 18, 18, 0.8)", 10000);
                return;

            } else if(result.data == true){
                props.ActionFunction();
            }
        })
    }

        setTimeout(() => {document.getElementById('MasterPopUpContainer').style.opacity = "1";},100);

         useEffect(() => {

        let totalLeft = 120;

        let i = setInterval(() => {

            if(totalLeft <= 0 ) {
                clearInterval(i);
                return;
            }

            totalLeft = totalLeft - 1;
            let min = String(Math.trunc(totalLeft/60)).padStart(2, "0");
            let sec = String(totalLeft%60).padStart(2, '0');
            setExpirationTime(`${min}:${sec}`);

            }, 1000);
        },[])

    return(
        <MasterContainer id="MasterPopUpContainer">
            <PopUpWarning />
            <TitleMasterContainer>
                <h1>Confirmação por Email</h1>
                <MailFigure />
            </TitleMasterContainer>
            <span>Enviamos um código de confirmação para seu email.<br/>
            O código expira em: <h2>{expirationTime}</h2>
            Por favor, insira aqui o código de validação para proseguir com sua solicitação: </span>

            <InputValidationCode onChange={(e) => validationCodeCheck(e.target.value)}></InputValidationCode>
                <EmailConfirmInput 
                    value="Validar Código"
                    available={availableValideCode}
                    color={ValideCodeButtonColor}
                    onClick={(event) => executeAction(event.target.previousSibling.value)}>Validar Codigo</EmailConfirmInput>
        </MasterContainer>
    )
}

export default EmailConfirmFormulary;
export { GenerateValidationCodeFunction };

const MasterContainer = styled.div`
    display: flex;
    width: 600px;
    text-align: center;
    flex-direction: column;
    align-items: center;
    background-color: white;
    padding: 20px 20px;
    transition: .7s ease-in-out;
    opacity: 0;
    border: solid 1px;
    border-radius: 10px;
    box-shadow: 10px 10px 10px 0 black;
    margin-bottom: 10px;

`

const InputValidationCode = styled.input`
    height: 30px;
    width: 200px;
    margin: 10px 0;
    border-radius: 0px;
    border: solid 1px rgba(0, 0, 0, 0.3);
    font-size: 16px;
    margin-top: 50px;

`

const EmailConfirmInput = styled.div`
    height: 50px;
    padding: 0px 5px;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0;
    border-radius: 5px;
    font-size: 14pt;
    border: none;
    background-color: ${props => props.color};
    color: white;
    cursor: pointer;
    transition: .3s ease-in-out;
    text-align: center;
    pointer-events: ${props => props.available};

    &:hover {
    scale: 1.1;
    
    }
`
const MailFigure = styled.div`
    background-image: url(${MailImg});
    background-size: cover;
    background-repeat; no-repeat;
    background-position: center center;
    width: 60px;
    height: 60px;
    margin-left: 20px;
    transition: .3s ease-in-out;
    cursor: pointer;

    &:hover {
    transform: rotate3d(0, 1, 1, 360deg);
    scale: 1.2
    }
`

const TitleMasterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
`

///Como usar: Chame o componente e passe as duas props  e a funcao a executar
//            <EmailConfirmFormulary 
//              ActionFunction={função desejada que executa o que você quer}
//              validationCode={GenerateValidationCodeFunction(nome do usuario, email do usuario)}>           
//            </EmailConfirmFormulary>);

